import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import usePageMetadata from '../hooks/usePageMetadata';
import * as authApi from '../api/endpoints/auth';
import { authSection, btnLg, btnPrimary, containerForm, focusRing, inputClass, labelClass } from '../styles/ui';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  usePageMetadata({
    title: 'Forgot Password | Fresh & Homely',
    description: 'Reset your Fresh & Homely account password.',
    canonicalPath: '/forgot-password',
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await authApi.forgotPassword(email.trim());
      navigate(`/reset-password?email=${encodeURIComponent(email.trim())}`);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <section className={authSection}>
        <div className={`${containerForm} w-full`}>
          <div className="bg-white/90 backdrop-blur-sm rounded-4xl border border-emerald-50 p-8 shadow-floating">
            <h1 className="serif text-3xl text-emerald-950 mb-2 text-center">Forgot password?</h1>
            <p className="text-ink-secondary text-center mb-8">We'll email you a reset code.</p>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="email" className={labelClass}>Email</label>
                <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} autoComplete="email" />
              </div>

              {error && <p className="text-sm text-red-600">{error}</p>}

              <button
                type="submit"
                disabled={submitting}
                className={`w-full ${btnPrimary} ${btnLg}`}
              >
                {submitting ? 'Sending...' : 'Send Reset Code'}
              </button>
            </form>

            <p className="mt-6 text-center text-sm text-ink-secondary">
              <Link to="/login" className={`text-emerald-700 hover:text-emerald-800 font-medium ${focusRing}`}>
                Back to sign in
              </Link>
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ForgotPasswordPage;
